import {
  HIDE_TOAST,
  SET_LOADING,
  SET_PERMISSION,
  SET_USER,
  SHOW_TOAST,
} from "./types";

//Set User
export const setUser = (user) => {
  return {
    type: SET_USER,
    payload: {
      currentUser: user,
    },
  };
};

//Set Permissions
export const setPermission = (permissions) => {
  return {
    type: SET_PERMISSION,
    payload: permissions,
  };
};

//Main Loading of user
export const setUserLoading = (loading) => {
  return {
    type: SET_LOADING,
    payload: {
      loading,
    },
  };
};

//Toast show/hide
export const showToast = (payload) => {
  return {
    type: SHOW_TOAST,
    payload,
  };
};

export const hideToast = () => {
  return {
    type: HIDE_TOAST,
  };
};